import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './DepartmentList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const DepartmentList = () => {
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(`${url}/api/department`);
        setDepartment(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch Department');
      } finally {
        setLoading(false);
      }
    };

    fetchDepartment();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/department/${id}`);
      setDepartment(department.filter(department => department._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete Department');
    }
  };

  if (loading) return <div className="loading">Loading Department...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Department List</h2>
        <button 
          onClick={() => navigate('/AddDepartment')}
          className="add-button"
        >
          <Plus size={16} /> Add Department
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Name</th>
            
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {department.map(department => (
            <tr key={department._id}>
              <td>{department.name}</td>
             
              <td className="actions">
                <button 
                  onClick={() => navigate(`/department/edit/${department._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(department._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DepartmentList;